export default __webpack_public_path__ + "static/media/header-bg.77d0b9fb.png";